import axios from 'axios';
import { store } from '../store';
import validateLogin from '../auth/validate-login';

export const logout = () => {
  const { token } = store.getState().auth;
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/token-auth/expire/`,
    headers: { Authorization: `Token ${token}` },
    data: { token },
  }).catch(() => {
    // noop
  }).finally(() => {
    window.location.href = '/';
  });
};

/**
 * Add to any axios catch() for 401 auth handling.
 */
export const default401 = (error) => {
  if (error.response && error.response.status === 401) {
    store.dispatch({ type: 'SET_AUTH_EXPIRED' });
    store.dispatch({ type: 'CLEAR' });
    logout();
  } else {
    throw error;
  }
};

export const login = (auth) => (
  axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/token-auth/admin/`,
    method: 'post',
    data: { email: auth.username, password: auth.password },
    withCredentials: true, // Amazon WAF token from our subdomain's .api. cookies
  }).then(({ data }) => {
    validateLogin(data);
    const { token } = data;
    window.localStorage.setItem('SessionToken', token);
    store.dispatch({ type: 'LOGIN', user: data });
  }).catch(({ response, message }) => {
    if (response && response.status === 400) {
      throw new Error('Unrecognized login information.');
    }
    if (response && response.status === 401) {
      throw new Error('You are not authorized for this site.');
    }
    throw new Error(message);
  })
);

export const checkIfLoggedIn = () => (
  axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/check-if-logged-in/`,
    headers: { Authorization: `Token ${store.getState().auth.token}` },
  }).catch(default401)
);

export const checkIfLoggedInNoCatch = () => (
  axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/check-if-logged-in/`,
    headers: { Authorization: `Token ${store.getState().auth.token}` },
  })
);
